import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SavedDataInfo } from '../../../../../models/form/saved-data-info';
import { CustomerService } from '../../../../../services/api/customer.service';
import { CustomersClientTypesFormComponent } from '../../../components/customers-client-types-form/customers-client-types-form.component';

@Component({
  selector: 'app-customers-client-types-edit-page',
  imports: [CustomersClientTypesFormComponent],
  templateUrl: './customers-client-types-edit-page.component.html',
  styleUrl: './customers-client-types-edit-page.component.scss'
})
export class CustomersClientTypesEditPageComponent {
  clientTypeId!: number
  clientType?: any;

  constructor(
    private route: ActivatedRoute,
    private customersService: CustomerService,
  ) {
  }

  ngOnInit(): void {
    this.clientTypeId = Number(this.route.snapshot.paramMap.get('clientTypeId'));
    if (this.clientTypeId) {
      this.loadData(this.clientTypeId);
    }
  }

  loadData(clientTypeId: any) {
    this.customersService.detailSettingsClientsTypes(clientTypeId).subscribe((response: any) => {
      this.clientType = response?.data?.customerType;
    });

  }
  onItemProductFormSavedData(savedDataInfo: SavedDataInfo) {
    if (savedDataInfo.success) {      
      this.loadData(savedDataInfo.response?.data?.customerType?.customerTypeId);
    }
  }
}
